import { BaseKey, BaseRecord, DataProvider, DeleteOneResponse, MetaQuery } from "@refinedev/core";
import apiHelper from "api/apiHelper";

const dataProvider: DataProvider = {
  getList: async (params) => {
    const { resource, pagination, filters, sorters } = params;
    let url = "/" + resource;
    let searchParams = new URLSearchParams();
    if (pagination) {
      searchParams.set("page", String(pagination.current ?? 1));
      searchParams.set("perPage", String(pagination.pageSize ?? 10));
    }
    if (filters) {
      for (const filter of filters) {
        if ("field" in filter && filter.operator === "eq") {
          searchParams.set(filter.field, filter.value);
        } else if ("field" in filter && filter.operator === "lte") {
          searchParams.set(`${filter.field}_lt`, filter.value);
        } else if ("field" in filter && filter.operator === "gte") {
          searchParams.set(`${filter.field}_gt`, filter.value);
        } else if ("field" in filter && filter.operator === "in") {
          searchParams.set(`${filter.field}`, filter.value[0] || "");
        } else {
          console.warn("Invalid Filter:", filter);
        }
      }
    }
    if (sorters) {
      for (const sorter of sorters) {
        searchParams.set("sort", sorter.field);
        searchParams.set("order", sorter.order);
      }
    }
    url += `?${searchParams.toString()}`;
    const { data } = await apiHelper.get(url, {});
    return {
      data: data.data,
      total: data.length
    };
  },

  getOne: async (params) => {
    const { resource, id, meta } = params;
    const { data } = await apiHelper.get(`/${resource}/${id}`, {});
    return data;
  },

  create: async (params) => {
    const { resource, variables, meta } = params;
    const { data } = await apiHelper.post(`/${resource}`, variables);
    return {
      data: data
    };
  },

  update: async (params) => {
    const { resource, id, variables, meta } = params;
    let res: { data: any };
    if (meta?.method?.toLowerCase() === "patch") {
      res = await apiHelper.patch(`/${resource}/${id}`, variables);
    } else {
      res = await apiHelper.put(`/${resource}/${id}`, variables);
    }
    return {
      data: res.data
    };
  },

  deleteOne: async <TData extends BaseRecord = BaseRecord, TVariables = {}>(params: {
    resource: string;
    id: BaseKey;
    variables?: TVariables;
    meta?: MetaQuery;
    metaData?: MetaQuery;
  }): Promise<DeleteOneResponse<TData>> => {
    const { resource, id, meta } = params;
    const data = await apiHelper.delete(`/${resource}/${id}`, {});
    return data;
  },

  deleteMany: async <TData extends BaseRecord = BaseRecord, TVariables = {}>(params: {
    resource: string;
    ids: BaseKey[];
    variables?: TVariables;
    meta?: MetaQuery;
    metaData?: MetaQuery;
  }): Promise<DeleteOneResponse<TData>> => {
    const { resource, ids, meta } = params;
    const data = await apiHelper.post(`/${resource}/deleteMany`, {
      ids: ids
    });
    return data;
  },

  getApiUrl: () => {
    return "";
  }
};

export default dataProvider;
